"use client"
import React from "react"
import Title from "../Title/Title"
import "aos/dist/aos.css"

// Example logo URLs (replace with your actual logo paths)
const logos = Array.from({ length: 22 }, (_, i) => `/clients/c-${i + 1}.png`)

function Marquee() {
  return (
    <div
      className="flex my-16 overflow-hidden bg-white"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      <div className="flex flex-col xl:flex-row  ps-6 xl:ps-16 3xl:ps-24 xl:py-8 items-center justify-between">
        <div className="flex w-full xl:w-[10%]">
          <Title
            title=""
            black="clients"
            grey="we protect"
            type="h2"
            className="uppercase text-[24px] xl:text-[60px]"
          />
        </div>
        <div className=" flex xl:w-[85%] icons overflow-hidden">
          <div
            style={{
              display: "flex",
              whiteSpace: "nowrap",
              animation: "marquee 20s linear infinite",
            }}
          >
            {[...logos, ...logos].map((logo, idx) => (
              <img
                width="200"
                height="100"
                src={logo}
                alt={`Client logo ${(idx % logos.length) + 1}`}
                key={idx}
                loading="lazy"
                decoding="async"
                className="h-[80px] xl:h-[150px] object-contain mr-6 xl:mr-20"
              />
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  )
}

export default Marquee
